(function () {
  const getCssLength = (el, prop, fallback) => {
    const value = parseFloat(getComputedStyle(el).getPropertyValue(prop));
    return Number.isFinite(value) ? value : fallback;
  };

  document.addEventListener("DOMContentLoaded", () => {
    mainSliders = document.querySelectorAll(
      '[data-target="main-slider-container"]',
    );
    productsSliders = document.querySelectorAll(
      '[data-target="products-slider-container"]',
    );
    reviewsSliders = document.querySelectorAll(
      '[data-target="reviews-slider-container"]',
    );

    if (mainSliders) {
      mainSliders.forEach((sliderElem, index) => {
        const slider = new Swiper(sliderElem, {
          slidesPerView: 1,
          spaceBetween: 20,
          loop: false,
          pagination: {
            el: sliderElem
              .closest(".swiper-custom-wrapper")
              ?.querySelector(".swiper-pagination"),
            clickable: true,
          },

          navigation: {
            nextEl: sliderElem
              .closest(".swiper-custom-wrapper")
              ?.querySelector(".swiper-button-next"),
            prevEl: sliderElem
              .closest(".swiper-custom-wrapper")
              ?.querySelector(".swiper-button-prev"),
          },
        });
      });
    }

    if (productsSliders) {
      productsSliders.forEach((sliderElem, index) => {
        const slider = new Swiper(sliderElem, {
          slidesPerView: 1.3,
          spaceBetween: getCssLength(sliderElem, "--grid-column-gap", 20),
          loop: false,
          observer: true,
          observeParents: true,
          pagination: {
            el: sliderElem
              .closest(".swiper-custom-wrapper")
              ?.querySelector(".swiper-pagination"),
            clickable: true,
          },

          navigation: {
            nextEl: sliderElem
              .closest(".swiper-custom-wrapper")
              ?.querySelector(".swiper-button-next"),
            prevEl: sliderElem
              .closest(".swiper-custom-wrapper")
              ?.querySelector(".swiper-button-prev"),
          },

          breakpoints: {
            768: {
              slidesPerView: 4,
              spaceBetween: 14,
            },

            1201: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
          },

          on: {
            beforeResize(swiper) {
              swiper.params.spaceBetween = getCssLength(
                swiper.el,
                "--grid-column-gap",
                20,
              );
              swiper.params.slidesOffsetAfter = getCssLength(
                swiper.el,
                "--padding-container",
                40,
              );
            },
          },
        });
      });
    }

    if (reviewsSliders) {
      reviewsSliders.forEach((sliderElem) => {
        const wrapper = sliderElem.querySelector(".swiper-wrapper");
        const originalSlides = Array.from(wrapper?.children || []);
        const slidesCount = originalSlides.length;

        if (wrapper && slidesCount > 1) {
          const beforeSlides = document.createDocumentFragment();
          const afterSlides = document.createDocumentFragment();

          originalSlides.forEach((slide) => {
            beforeSlides.appendChild(slide.cloneNode(true));
            afterSlides.appendChild(slide.cloneNode(true));
          });

          wrapper.prepend(beforeSlides);
          wrapper.append(afterSlides);
        }

        const syncActiveSlide = (swiper) => {
          let activeIndex = swiper.activeIndex;

          if (slidesCount > 1) {
            if (activeIndex < slidesCount) {
              activeIndex += slidesCount;
            } else if (activeIndex >= slidesCount * 2) {
              activeIndex -= slidesCount;
            }
          }

          if (activeIndex !== swiper.activeIndex) {
            swiper.el.classList.add("swiper_reviews_no-transition");
            swiper.slideTo(activeIndex, 0, false);

            requestAnimationFrame(() => {
              swiper.el.classList.remove("swiper_reviews_no-transition");
            });
          }

          swiper.updateSlides();
          swiper.slideTo(activeIndex, 0, false);
        };

        new Swiper(sliderElem, {
          slidesPerView: "auto",
          centeredSlides: false,
          spaceBetween: 14,
          initialSlide: slidesCount > 1 ? slidesCount : 0,
          loop: false,
          speed: 500,
          allowTouchMove: true,
          navigation: {
            nextEl: sliderElem
              .closest(".swiper-custom-wrapper")
              ?.querySelector(".swiper-button-next"),
            prevEl: sliderElem
              .closest(".swiper-custom-wrapper")
              ?.querySelector(".swiper-button-prev"),
          },
          breakpoints: {
            768: {
              centeredSlides: true,
              spaceBetween: 16,
              speed: 500,
              allowTouchMove: false,
            },
            1201: {
              centeredSlides: true,
              spaceBetween: 20,
              speed: 500,
              allowTouchMove: false,
            },
          },
          on: {
            init(swiper) {
              swiper.wrapperEl.addEventListener("transitionend", (event) => {
                if (event.target === swiper.wrapperEl) {
                  syncActiveSlide(swiper);
                }
              });

              requestAnimationFrame(() => syncActiveSlide(swiper));
            },
            slideChangeTransitionStart(swiper) {
              const activeIndex = swiper.activeIndex;
              swiper.updateSlides();
              swiper.slideTo(activeIndex, swiper.params.speed, false);
            },
            resize(swiper) {
              syncActiveSlide(swiper);
            },
          },
        });
      });
    }
  });
})();
